import { Box } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { People } from '~/services/Http';

import { CalendarHeader } from './components/CalendarHeader';
import { CalendarRows } from './components/CalendarRows';
import { useAbsenceCalendar } from './useAbsenceCalendar';
import { useSxStyles } from './useStyles';

export interface Props {
  teamAbsences: People.AbsenceDto[];
  publicHolidays?: People.PublicHolidayDto[];
  containerWidth: number;
  shouldRedirect: boolean;
}

export const AbsencesCalendar: React.FC<Props> = ({
  teamAbsences,
  publicHolidays,
  containerWidth,
  shouldRedirect,
}) => {
  const {
    viewStartDate,
    daysInView,
    handleCalendarNavigation,
    containerRef,
    endOfRange,
  } = useAbsenceCalendar();
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const minSizeRender = containerWidth < 400;

  return (
    <Box sx={sxStyles.contentWrapper}>
      <Box sx={sxStyles.calendarHeaderWrapper}>
        <Box sx={minSizeRender ? sxStyles.minLeftCell : sxStyles.leftCells}>
          {t('name')}
        </Box>
        <Box ref={containerRef} sx={sxStyles.rightCells}>
          <CalendarHeader
            viewStartDate={viewStartDate}
            daysInView={daysInView}
            handleCalendarNavigation={handleCalendarNavigation}
            endOfRange={endOfRange}
          />
        </Box>
      </Box>
      <Box sx={sxStyles.tableWrapper}>
        <CalendarRows
          minSizeRender={minSizeRender}
          teamAbsences={teamAbsences}
          publicHolidays={publicHolidays}
          daysInView={daysInView}
          endOfRange={endOfRange}
          shouldRedirect={shouldRedirect}
        />
      </Box>
    </Box>
  );
};
